import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import UserSidebar from './UserSidebar';

const PAGE_LABELS = {
  '/user/dashboard': 'Dashboard',
  '/user/filings':   'My Filings',
  '/user/documents': 'Documents',
  '/user/settings':  'Settings',
};

const UserLayout = () => {
  const { pathname } = useLocation();
  const pageLabel = PAGE_LABELS[pathname] ?? 'User Portal';

  const token = localStorage.getItem('auth_token');
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('auth_user'));
  } catch (e) {}

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        * { box-sizing: border-box; }

        .user-layout {
          display: flex;
          min-height: 100vh;
          background: #f8fafc;
          font-family: 'Inter', sans-serif;
        }

        .user-main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
          background: #f8fafc;
        }

        .user-top-header {
          height: 64px;
          background: #ffffff;
          border-bottom: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 28px;
          position: sticky;
          top: 0;
          z-index: 50;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
        }

        .user-header-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .user-breadcrumb {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #94a3b8;
        }

        .user-breadcrumb-sep { color: #cbd5e1; }

        .user-breadcrumb-current {
          color: #334155;
          font-weight: 600;
        }

        .user-header-right {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .user-header-icon-btn {
          width: 36px;
          height: 36px;
          border-radius: 9px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #64748b;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.18s;
          font-size: 14px;
          position: relative;
        }

        .user-header-icon-btn:hover {
          background: #f1f5f9;
          color: #334155;
          border-color: #cbd5e1;
        }

        .user-notif-badge {
          position: absolute;
          top: 7px;
          right: 7px;
          width: 7px;
          height: 7px;
          background: #3b82f6;
          border-radius: 50%;
          border: 2px solid #fff;
        }

        .user-header-divider {
          width: 1px;
          height: 22px;
          background: #e2e8f0;
          margin: 0 4px;
        }

        .user-user-profile {
          display: flex;
          align-items: center;
          gap: 9px;
          cursor: pointer;
          padding: 5px 12px 5px 5px;
          border-radius: 10px;
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          transition: all 0.18s;
        }

        .user-user-profile:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
        }

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: linear-gradient(135deg, #2563eb, #3b82f6);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 13px;
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
          flex-shrink: 0;
        }

        .user-user-text { display: flex; flex-direction: column; }

        .user-user-name-header {
          font-size: 13px;
          font-weight: 600;
          color: #0f172a;
          line-height: 1.2;
        }

        .user-user-role-header {
          font-size: 11px;
          color: #94a3b8;
        }

        .user-status-dot {
          width: 7px;
          height: 7px;
          background: #10b981;
          border-radius: 50%;
          box-shadow: 0 0 0 2px rgba(16,185,129,0.15);
          margin-left: 2px;
        }

        .user-content-area {
          flex: 1;
          padding: 28px 32px;
          overflow-y: auto;
        }
      `}</style>

      <div className="user-layout">
        <UserSidebar />
        <div className="user-main-content">
          <header className="user-top-header">
            <div className="user-header-left">
              <div className="user-breadcrumb">
                <span>Legal Infos</span>
                <span className="user-breadcrumb-sep">›</span>
                <span>User</span>
                <span className="user-breadcrumb-sep">›</span>
                <span className="user-breadcrumb-current">{pageLabel}</span>
              </div>
            </div>
            <div className="user-header-right">
              <button className="user-header-icon-btn" title="Search">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
              <button className="user-header-icon-btn" title="Notifications">
                <i className="fa-solid fa-bell"></i>
                <span className="user-notif-badge"></span>
              </button>
              <div className="user-header-divider"></div>
              <div className="user-user-profile">
                <div className="user-avatar">{user.name ? user.name.charAt(0).toUpperCase() : 'U'}</div>
                <div className="user-user-text">
                  <span className="user-user-name-header">{user.name || 'User'}</span>
                  <span className="user-user-role-header">Client</span>
                </div>
                <div className="user-status-dot"></div>
              </div>
            </div>
          </header>
          <main className="user-content-area">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default UserLayout;
